const isValidDomain = (domain: string) => {
	const domainPattern =
		/^(?!:\/\/)(?!-)[a-zA-Z0-9-](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.(?!-)[a-zA-Z0-9-](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z0-9-]{2,}$/;
	return domainPattern.test(domain);
};

export default isValidDomain;
